import React, { createContext, useContext, useState, useCallback } from "react";

const NotifContext = createContext(null);

export function NotifProvider({ children }) {
  const [notifs, setNotifs] = useState([]);

  const push = useCallback((msg, type = "info") => {
    const id = Date.now() + Math.random();
    setNotifs(n => [{ id, msg, type, time: new Date() }, ...n].slice(0, 20));
    // Auto-dismiss toast after 5s
    setTimeout(() => dismiss(id), 5000);
    return id;
  }, []);

  const dismiss = useCallback((id) => {
    setNotifs(n => n.filter(x => x.id !== id));
  }, []);

  const clearAll = useCallback(() => setNotifs([]), []);

  return (
    <NotifContext.Provider value={{ notifs, push, dismiss, clearAll }}>
      {children}
    </NotifContext.Provider>
  );
}

export function useNotifs() {
  return useContext(NotifContext);
}
